import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";

interface AuthCrossLinkProps {
    prompt: string;
    linkLabel: string;
    to: string;
    search?: Record<string, unknown>;
    className?: string;
}

/** Secondary navigation between auth flows (login, signup, smart auth). */
export function AuthCrossLink({ prompt, linkLabel, to, search, className }: AuthCrossLinkProps) {
    return (
        <p className={cn("text-muted-foreground text-sm text-center", className)}>
            {prompt}{" "}
            <Link
                to={to}
                search={search as never}
                className="font-medium text-primary hover:underline underline-offset-4"
            >
                {linkLabel}
            </Link>
        </p>
    );
}
